import React from 'react'
import {Grid, FormControl, InputLabel, TextField, FormHelperText} from '@material-ui/core'
export default function WURLField({data, onChange}) {
  return (
    <Grid item xs={6}>
      <FormControl fullWidth variant="outlined" className="ap-textfield" style={{width: 320}}>
        <TextField
          id="outlined-adornment-amount"
          value={data.value}
          onChange={e => {
            onChange(e, 'value', data)
          }}
          type={'url'}
          labelWidth={60}
          label={data.name}
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
        />
        <FormHelperText>{!data.is_required ? 'optional' : ''}</FormHelperText>
      </FormControl>
    </Grid>
  )
}
